import * as atlas from 'azure-maps-control';
import { MobileStockLocationSession } from '../../../../types/mobile_stock_location';
import { StockLocation } from '../../../../types/stock_location';
import { Marker } from '../markers/Marker';

export abstract class MarkerLayer<M extends Marker = Marker> {
  get options(): atlas.SymbolLayerOptions {
    return {
      iconOptions: {
        size: 1.5,
        image: ['get', 'image'],
      },
      textOptions: {
        color: 'white',
        size: 14,
        font: ['StandardFont-Bold'],
        offset: [0, -2.03],
      },
    };
  }
  popupBuilder?: (props: M) => React.ReactNode;
  abstract markerBuilder: (stockLocation: StockLocation, session?: MobileStockLocationSession) => M;
}
